module.exports = __webpack_public_path__ + "img/1_b.8dd6b458.jpg";